// AdvertiserContext.js

import { createContext, useState, useEffect, useContext } from 'react'
import { useLocalStorage } from '../hooks/useLocalStorage'
import { SharedContext } from './SharedContext'
import {
  getMethod,
  fetchContextData,
  getTheStatusOfRecruiterAlreadyPostedAJob
} from '../utils/functions'
import Cookies from 'universal-cookie'
import { useRouter } from 'next/router'
import { Media } from '../commonComponents/Media'
import classNames from 'classnames'

import dynamic from 'next/dynamic'
import { FORM_KEYS } from '../constants/hire/advertiserForm'
// Default exports
const AdvertiserBackModal = dynamic(() => import('../commonComponents/AdvertiserBackModal'), {
  ssr: false
})

const BottomSheetNudge = dynamic(() => import('../commonComponents/BottomSheetNudge'), {
  ssr: false
})

// Named exports
const SkeletonsHandler = dynamic(
  () => import('../components/SkeletonsHandler').then((mod) => mod.SkeletonsHandler),
  {
    ssr: false
  }
)

const Toast = dynamic(() => import('../components/Toast').then((mod) => mod.Toast), {
  ssr: false
})

const AdvertiserToast = dynamic(
  () => import('../advertiserComponents/AdvertiserToast').then((mod) => mod.AdvertiserToast),
  {
    ssr: false
  }
)

const BackModal = dynamic(
  () => import('../commonComponents/BackModal').then((mod) => mod.BackModal),
  {
    ssr: false
  }
)

const FooterModal = dynamic(
  () => import('../components/FooterModal').then((mod) => mod.FooterModal),
  {
    ssr: false
  }
)

const HamburgerMenu = dynamic(
  () => import('@/components/HamburgerMenu').then((mod) => mod.HamburgerMenu),
  {
    ssr: false
  }
)

export const AdvertiserContext = createContext()

export const AdvertiserContextProvider = ({ children }) => {
  // ----------- U STATES (useState) -----------
  const [isAdvertiserMenuClicked, setAdvertiserMenuClicked] = useState(false)
  const [showAdvertiserToast, setShowAdvertiserToast] = useState({ isVisible: false })
  const [isBackModalOpen, setBackModalOpen] = useState(false)
  const [isPaymentBackModalOpen, setPaymentBackModalOpen] = useState(false)
  const [isPlanSelected, setIsPlanSelected] = useState(true)
  const [isDistrictSelected, setIsDistrictSelected] = useState(false)
  const [isFirstTimeAdvertiser, setIsFirstTimeAdvertiser] = useState(null)
  const [totalAmount, setTotalAmount] = useState('')
  const [orderId, setOrderId] = useState('')
  const [languageFromAndroid, setLanguagefromAndriod] = useState('en')
  const [editJobStatus, setEditJobStatus] = useState('')
  const [submissionId, setSubmissionId] = useState(null)
  const [editJobSubmissionId, setEditJobSubmissionId] = useState()
  const [jobDistrictList, setJobDistrictList] = useState([])
  const [inStepFour, setStepFour] = useState(false)
  const [isResponsesClicked, setResponsesClicked] = useState(false)
  const [enterpriserFlow, setEnterpriserFlow] = useState(false)
  const [isEditReportClicked, setEditReportclicked] = useState(false)
  const [isDashboardButtonClicked, setIsDashboardButtonClicked] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [advertiserBackModalOpen, setAdvertiserBackModalOpen] = useState({
    isOpen: false,
    data: {},
    id: '',
    buttonTitles: ['', ''],
    onClickActions: [() => {}, () => {}],
    title: '',
    caption: ''
  })
  const [isComponentOpen, setComponentOpen] = useState(false)
  // Doc flow
  const [docUpload, setDocUpload] = useState(false)
  const [isUploadModalOpen, setUploadModalOpen] = useState(true)
  const [documentNumberLimit, setDocumentNumberLimit] = useState('50')
  const [documentNumberType, setDocumentNumberType] = useState()
  const [isFocusInput, setFocusInput] = useState(false)

  // ----------- L STATES (useLocalStorage) -----------
  const [formData, setFormData] = useLocalStorage('formData', {})
  const [tempFormData, setTempFormData] = useLocalStorage('tempFormData', {
    data: {},
    isPresent: false,
    title: 'Edit your job post'
  })
  const [updatedSuccessful, setUpdatedSuccessful] = useLocalStorage('updatedSuccessful', false)
  const [postJobPresentStep, setpostJobPresentStep] = useLocalStorage('postJobPresentStep', 1)
  const [formContext, setFormContext] = useLocalStorage('formContext', {})
  const [isSubmitPageViewed, setSubmitPageViewed] = useLocalStorage('isSubmitPageViewed', '')
  const [advertiserJobsStateIndex, setAdvertiserJobsStateIndex] = useLocalStorage(
    'advertiserJobsStateIndex',
    null
  )
  const [selectedCandidateIndex, setSelectedCandidateIndex] = useLocalStorage(
    'selectedCandidateIndex',
    0
  )
  const [advertiserCandidateTabIndex, setAdvertiserCandidateTabIndex] = useLocalStorage(
    'advertiserCandidateTabIndex',
    0
  )
  const [queryParams, setQueryParams] = useLocalStorage('queryParams', '')
  const [isReviewPageOpended, setReviewPageOpended] = useLocalStorage('isReviewPageOpended', false)
  const [isSuccess, setIsSuccess] = useLocalStorage('isSuccess', 'default')
  const [isPaymentSuccess, setPaymentSuccesss] = useLocalStorage('isPaymentSuccess', false)
  const [submittedJobId, setSubmittedJobId] = useLocalStorage('submittedJobId', null)
  const [packagesPresent, setPackagesPresent] = useLocalStorage('packagesPresent', true)
  const [skills, setSkills] = useLocalStorage('skills', [])
  const [selectedData, setSelectedData] = useLocalStorage('selectedData', {})
  const [isPayMentFailed, setPayMentFailed] = useLocalStorage('isPayMentFailed', {
    isfaild: false,
    selectedPlan: undefined,
    selectedPack: undefined,
    totalAmount: 0
  })
  const [enterpriseLoginDetails, setEnterpriseLoginDetails] = useLocalStorage(
    'enterpriseLoginDetails',
    {}
  )
  const [enterprisePlanOptions, setEnterprisePlanOptions] = useLocalStorage(
    'enterprisePlanOptions',
    {}
  )
  const [showEdit, setShowEdit] = useLocalStorage('showEdit', true)
  const [variant, setVariant] = useLocalStorage('variant', null)
  const [postingLocationLocale, setPostingLocationLocale] = useLocalStorage(
    'postingLocationLocale',
    'te'
  )
  // Doc flow
  const [apiFailed, setApiFailed] = useLocalStorage('apiFailed', false)
  const [docUpdatedSuccessfully, setDocUpdatedSuccessfully] = useLocalStorage(
    'docUpdatedSuccessfully',
    false
  )

  const {
    loginDetails,
    windowSize,
    setScrollBar,
    isMenuClicked,
    setMenuClicked,
    showToast,
    skeletonloader
  } = useContext(SharedContext)

  const cookie = new Cookies()
  const router = useRouter()

  const getUserVariant = async () => {
    if (typeof Android !== 'undefined') {
      setVariant('pay_later')
      return
    }
    if (enterpriseLoginDetails?.advertiserId || windowSize > 640) {
      setVariant('pay_now')
      return
    }
    try {
      // const data = await getMethod({
      //   url: process?.env?.NEXT_PUBLIC_BASE_URL_ADS + `/advertisers/advertisers/me/`
      // })
      setVariant('pay_later')
    } catch (error) {
      setVariant('pay_later')
      console.error('something went wrong in getting the variant')
    }
  }

  const getStatusOfRecruiterOnPostingAJob = async () => {
    const response = await getTheStatusOfRecruiterAlreadyPostedAJob()
    if ('status' in response) setIsFirstTimeAdvertiser(response?.status)
  }

  const advertiserBackModalClose = () => {
    setAdvertiserBackModalOpen({
      isOpen: false,
      data: {},
      id: '',
      buttonTitles: ['', ''],
      onClickActions: [() => {}, () => {}],
      title: '',
      caption: ''
    })
  }

  const popAdvertiserPage = () => {
    closeAdvertiserComponents()
    // If you had an advertiser pageTitles, you can do it here
    return false
  }

  const closeAdvertiserComponents = () => {
    setAdvertiserMenuClicked(false)
    setScrollBar(true)
    advertiserBackModalClose()
  }

  const backModalClose = () => {
    setBackModalOpen(false)
  }

  // ----------- USE EFFECT -----------
  useEffect(() => {
    if (loginDetails?.isLogIn || typeof Android !== 'undefined') {
      getUserVariant()
    }
  }, [loginDetails?.isLogIn])

  useEffect(() => {
    if (formContext?.job_category_list) {
      const category = formContext?.job_category_list.find(
        (item) => item?.id === formData?.job_category
      )
      setSelectedCategory(category)
    }
  }, [formContext?.job_category_list, formData?.job_category])

  useEffect(() => {
    const jobIndex = advertiserJobsStateIndex != null ? advertiserJobsStateIndex : 0
    cookie.set('advertiserJobsStateIndex', jobIndex, { path: '/' })
  }, [advertiserJobsStateIndex])

  useEffect(() => {
    if (enterpriseLoginDetails?.advertiserId && Number(advertiserJobsStateIndex) > 2) {
      setAdvertiserJobsStateIndex(0)
    }
  }, [enterpriseLoginDetails?.advertiserId, advertiserJobsStateIndex])

  useEffect(() => {
    cookie.set('selectedCandidateIndex', selectedCandidateIndex, { path: '/' })
  }, [selectedCandidateIndex])

  useEffect(() => {
    cookie.set('advertiserCandidateTabIndex', advertiserCandidateTabIndex, { path: '/' })
  }, [advertiserCandidateTabIndex])

  useEffect(() => {
    if (loginDetails?.isLogIn) {
      fetchContextData({
        cookie,
        setFormContext,
        isEnterprise: !!enterpriseLoginDetails?.advertiserId
      })
      getStatusOfRecruiterOnPostingAJob()
    }
  }, [loginDetails?.isLogIn])

  useEffect(() => {
    closeAdvertiserComponents()
  }, [])

  useEffect(() => {
    if (isAdvertiserMenuClicked || isMenuClicked) {
      setComponentOpen(true)
    } else if (isComponentOpen) {
      setComponentOpen(false)
    }
  }, [isAdvertiserMenuClicked, isMenuClicked])

  useEffect(() => {
    const handleStart = async (url) => {
      let prvData = JSON.parse(localStorage.getItem('historyStack') || '[]') || []
      if (prvData?.data?.[prvData?.data?.length - 2]?.as === url) {
        // if route is advertiser route => do your logic
        if (router.pathname === '/advertiserPostJob') {
          history.forward()
          if (postJobPresentStep === 1 && !isDashboardButtonClicked) setBackModalOpen(true)
          else if (postJobPresentStep === 4) {
            setPaymentBackModalOpen(true)
          } else {
            setpostJobPresentStep((prev) => (prev !== 1 ? prev - 1 : prev))
            setBackModalOpen(false)
          }
        } else if (router.pathname === '/advertiserJobReview') {
          const previousPath = prvData?.data?.at(-2)?.pathname
          if (previousPath === '/advertiserDashboardPage' && tempFormData?.isPresent) {
            setTimeout(
              () =>
                setTempFormData((prevTemp) => {
                  setFormData(prevTemp?.data)
                  return { data: {}, isPresent: false, title: 'Edit your job post' }
                }),
              2500
            )
          }
        }
      }
    }

    const popState = async () => {
      popAdvertiserPage()
    }

    router.events.on('routeChangeStart', handleStart)
    addEventListener('popstate', popState)
    setIsDashboardButtonClicked(false)

    return () => {
      router.events.off('routeChangeStart', handleStart)
      removeEventListener('popstate', popState)
    }
  }, [
    router,
    isComponentOpen,
    postJobPresentStep,
    tempFormData,
    isBackModalOpen,
    isDashboardButtonClicked
  ])

  const updateEducationField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [FORM_KEYS?.EDUCATION_DATA]: [
        {
          ...prev[FORM_KEYS?.EDUCATION_DATA]?.[0],
          [field]: value
        }
      ]
    }));
    setFormData((prev) => ({
      ...prev,
          [field]: value
    }));
  };

  return (
    <AdvertiserContext.Provider
      value={{
        // U states
        isAdvertiserMenuClicked,
        setAdvertiserMenuClicked,
        showAdvertiserToast,
        setShowAdvertiserToast,
        isBackModalOpen,
        setBackModalOpen,
        isPaymentBackModalOpen,
        setPaymentBackModalOpen,
        isPlanSelected,
        setIsPlanSelected,
        isDistrictSelected,
        setIsDistrictSelected,
        isFirstTimeAdvertiser,
        setIsFirstTimeAdvertiser,
        totalAmount,
        setTotalAmount,
        orderId,
        setOrderId,
        languageFromAndroid,
        setLanguagefromAndriod,
        editJobStatus,
        setEditJobStatus,
        editJobSubmissionId,
        setEditJobSubmissionId,
        jobDistrictList,
        setJobDistrictList,
        inStepFour,
        setStepFour,
        isResponsesClicked,
        setResponsesClicked,
        enterpriserFlow,
        setEnterpriserFlow,
        isEditReportClicked,
        setEditReportclicked,
        isDashboardButtonClicked,
        setIsDashboardButtonClicked,
        selectedCategory,
        setSelectedCategory,
        advertiserBackModalOpen,
        setAdvertiserBackModalOpen,
        submissionId,
        setSubmissionId,
        // doc flow
        docUpload,
        setDocUpload,
        isUploadModalOpen,
        setUploadModalOpen,
        documentNumberLimit,
        setDocumentNumberLimit,
        documentNumberType,
        setDocumentNumberType,
        isFocusInput,
        setFocusInput,

        // L states
        formData,
        setFormData,
        tempFormData,
        setTempFormData,
        updatedSuccessful,
        setUpdatedSuccessful,
        postJobPresentStep,
        setpostJobPresentStep,
        formContext,
        setFormContext,
        isSubmitPageViewed,
        setSubmitPageViewed,
        advertiserJobsStateIndex,
        setAdvertiserJobsStateIndex,
        selectedCandidateIndex,
        setSelectedCandidateIndex,
        advertiserCandidateTabIndex,
        setAdvertiserCandidateTabIndex,
        queryParams,
        setQueryParams,
        isReviewPageOpended,
        setReviewPageOpended,
        isSuccess,
        setIsSuccess,
        isPaymentSuccess,
        setPaymentSuccesss,
        submittedJobId,
        setSubmittedJobId,
        packagesPresent,
        setPackagesPresent,
        skills,
        setSkills,
        selectedData,
        setSelectedData,
        isPayMentFailed,
        setPayMentFailed,
        enterpriseLoginDetails,
        setEnterpriseLoginDetails,
        enterprisePlanOptions,
        setEnterprisePlanOptions,
        showEdit,
        setShowEdit,
        variant,
        setVariant,
        postingLocationLocale,
        setPostingLocationLocale,
        apiFailed,
        setApiFailed,
        docUpdatedSuccessfully,
        setDocUpdatedSuccessfully,

        //helpers
        advertiserBackModalClose,
        // updateField,
        updateEducationField,
      }}
    >
      {skeletonloader?.isVisible && <SkeletonsHandler skeletonName={skeletonloader?.pathName} />}
      <Media at="sm">
        {!skeletonloader?.isVisible &&
          (isMenuClicked ? (
            <HamburgerMenu
              {...{
                setMenuClicked,
                isMenuClicked,
                enterpriseLoginDetails,
                setEnterpriseLoginDetails,
                setAdvertiserBackModalOpen,
                setAdvertiserMenuClicked,
                advertiserBackModalClose
              }}
            />
          ) : (
            children
          ))}
      </Media>
      <Media greaterThan="sm">
        {(isMenuClicked || isAdvertiserMenuClicked || advertiserBackModalOpen?.isOpen) && (
          <div
            className={classNames(
              'fixed z-50 h-full w-full'
            )}
            onClick={closeAdvertiserComponents}
          />
        )}
        {!skeletonloader?.isVisible && children}
      </Media>
      {showToast?.isVisible && (
        <Toast
          {...{
            toastDetails: showToast?.details
          }}
        />
      )}
      {showAdvertiserToast?.isVisible && (
        <AdvertiserToast
          {...{
            toastDetails: showAdvertiserToast?.details
          }}
        />
      )}
      {variant == 'pay_now' ? (
        <BackModal
          {...{ isBackModalOpen, backModalClose, postJobPresentStep, setpostJobPresentStep }}
        />
      ) : (
        <FooterModal
          {...{
            isOpen: isBackModalOpen,
            handleModalClose: backModalClose,
            isHeaderPresent: false,
            headerClassName: 'shadow-base',
            className: 'max-h-[85vh]'
          }}
        >
          <>
            <BottomSheetNudge
              {...{
                headerImage: 'bottomNudgeImage',
                closeIconHandler: backModalClose,
                onClickHandler: backModalClose,
                category: selectedCategory?.title_trans,
                totalCandidates: selectedCategory?.available_job_seekers
              }}
            />
          </>
        </FooterModal>
      )}
      <AdvertiserBackModal />
    </AdvertiserContext.Provider>
  )
}
